import { defineTranslationScope } from "@app/shared/i18n/translation-scope";

export const scope = defineTranslationScope("shared/organisms/cerrix-link-items-dialog");
